import { Cache } from "aws-amplify";
import axios from "axios";
import APIClient from "../../../common/APIClient";
import pkceChallenge from "pkce-challenge";

const authClient = () => {
  var env = process.env.REACT_APP_BACKEND_ENV;
  var base_path = "";

  switch (env) {
    case "prod":
      base_path = process.env.REACT_APP_ACP_BACKEND_BASE_PATH_PROD;
      break;
    case "test":
    case "uat":
      base_path = process.env.REACT_APP_ACP_BACKEND_BASE_PATH_TEST;
      break;
    case "dev":
      base_path = process.env.REACT_APP_ACP_BACKEND_BASE_PATH_DEV;
      break;
    default:
      base_path = process.env.REACT_APP_ACP_BACKEND_BASE_PATH_LOCAL;
      break;
  }

  axios.interceptors.request.use(
    (config) => {
      config.baseURL = base_path;

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  return axios;
};

const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
};

/**
 * Create Token from Authorization code
 *
 * @author Mark Kenneth Esguerra
 */

export const redirectToLogin = () => {
  localStorage.clear();
  Cache.clear();
  window.location.href = `${process.env.REACT_APP_REDIRECT_URI}/#/login/`;
};
export const redirectToDashboard = () => {
  window.location.href = `${process.env.REACT_APP_REDIRECT_URI}/#/dashboard/`;
};

export const loginUser = async (credentials) => {
  return await authClient()
    .post("/admin/login", credentials)
    .then(async (json) => {
      const result = json.data;
      if (result.status_code === 200 && result.data.original.success) {
        const token = result.data.original.token;
        Cache.setItem("token", token);
        const userdata = await setUserData();
        return userdata;
      } else return false;
    })
    .catch((e) => {
      console.error(e);
      return null;
    });
};

export const verifyEmail = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return await authClient()
    .get("/admin/verify", config)
    .then(async (json) => {
      const result = json.data;
      console.log("verify json", result);
      if (result.status_code === 200) return result;
    })
    .catch((e) => {
      const errorResult = e.response.data;
      return errorResult;
    });
};

export const resendVerification = async (credentials) => {
  return await authClient()
    .post("/admin/resend-verify", credentials)
    .then(async (json) => {
      const result = json.data;
      console.log("resendverify json", result.status_code === 200);
      if (result.status_code === 200) return true;
      else return result;
    })
    .catch((e) => {
      const errorResult = e.response.data;
      return errorResult;
    });
};

export const forgotPassword = async (credentials) => {
  return await authClient()
    .post("/admin/forgot-password", credentials)
    .then(async (json) => {
      const result = json.data;
      if (result.status_code === 200) return true;
      else return result;
    })
    .catch((e) => {
      console.error(e);
      return null;
    });
};

export const updatePassword = async (credentials) => {
  const token = Cache.getItem("token");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return await authClient()
    .post("/admin/change-password", credentials, config)
    .then(async (json) => {
      const result = json.data;
      if (result.status_code === 200) return true;
      else return result;
    })
    .catch((e) => {
      console.error(e);
      return null;
    });
};

export const setUserData = (callback = null) => {
  const config = {
    headers: {
      Authorization: `Bearer ${Cache.getItem("token")}`,
    },
  };
  return authClient()
    .get("/admin/cache-info", config)
    .then((json) => {
      const result = json.data;
      if (result.status_code === 200) {
        const userData = result.data;
        Cache.setItem("userdata", userData);
      }

      if (callback) {
        callback();
      }
      return result;
    })
    .catch((e) => {
      console.error(e);
      return null;
    });
};
export const refreshToken = (callback = null) => {
  const config = {
    headers: {
      Authorization: `Bearer ${Cache.getItem("token")}`,
    },
  };
  return authClient()
    .post("/admin/refresh-token", config)
    .then((json) => {
      const result = json.data;
      if (result.status_code === 200) {
        Cache.setItem("token", result.refreshToken);
        if (callback) {
          callback();
        }
        return result.refreshToken;
      }

      return null;
    })
    .catch((e) => {
      return e.response.data.message;
    });
};

export const logoutUser = (callback = null) => {
  authClient()
    .post("/admin/logout")
    .then((json) => {
      const result = json.data;
      if (result) {
        localStorage.clear();
        Cache.clear();
        redirectToLogin();
        if (callback) {
          callback();
        }
      }
    })
    .catch((e) => {
      console.error(e);
      return null;
    });
};

export const getUserInfoByEmail = async (email) => {
  try {
    const response = await client().get("/users/getByEmail", {
      params: {
        email,
      },
    });

    const result = response?.data;
    return result?.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};
